module.exports = __webpack_public_path__ + "img/phone_4.ea43d49f.png";